import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { Box, Typography, Button, CircularProgress } from '@mui/material'
import { Refresh as RefreshIcon } from '@mui/icons-material'

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth()
  const [showTimeout, setShowTimeout] = useState(false)

  useEffect(() => {
    // Show timeout message after 5 seconds if still loading
    const timer = setTimeout(() => {
      if (loading) {
        setShowTimeout(true)
      }
    }, 5000)

    return () => clearTimeout(timer)
  }, [loading])

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '100vh',
          gap: 3
        }}
      >
        <CircularProgress size={48} />
        {showTimeout && (
          <>
            <Typography variant="body1" color="text.secondary">
              Taking longer than expected...
            </Typography>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={() => window.location.reload()}
              sx={{ mt: 2 }}
            >
              Refresh Page
            </Button>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
              If the problem persists, try clearing your browser data
            </Typography>
          </>
        )}
      </Box>
    )
  }

  return user ? children : <Navigate to="/login" replace />
}

export default ProtectedRoute